import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Post } from '@interfaces/api.post.interface';

@Component({
  selector: 'ark-ui-post-text',
  templateUrl: './ui-post-text.component.html',
  styleUrls: ['./ui-post-text.component.scss'],
})
export class UiPostTextComponent implements OnInit {
  @Input() post!: Post;

  @Output() postClicked = new EventEmitter<number>();
  @Output() postImageClicked = new EventEmitter<number>();
  limitCharacters: number | undefined = 100;
  twoLines = false;

  readMore = false;
  readMoreText: 'Read more...' | 'Read less...' = 'Read more...';
  readMoreExpanded = false;

  blured = false;

  constructor() {}

  ngOnInit(): void {
    // this.blured = !this.post.isMine;
    this.readMore = !this.post.isMine;
    this.limitCharacters = !this.post.isMine ? this.limitCharacters : undefined;
    this.twoLines = !this.post.wallPost;
  }

  postClick(e: Event) {
    this.postClicked.emit(this.post.postId);
  }

  imageClick(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    this.postImageClicked.emit(this.post.createdByUserId);
  }
}
